"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _router2 = require("@/router");
var _user = require("@/api/user");
var _settings = _interopRequireDefault(require("@/settings"));
var _layout = _interopRequireDefault(require("@/layout"));
// progress bar
// progress bar style
// get token from cookie

// 新代码
//Layout 是架构组件，不在后台返回，在文件里单独引入
// 处理路由
var _import = require('@/utils/_import_' + process.env.NODE_ENV); //获取组件的方法
var getRouter; //用来获取后台拿到的路由
//处理title
var title = _settings.default.title;
function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }
  return "".concat(title);
}
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/chainIndex', '/chainDetail']; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var hasToken;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          _nprogress.default.start();
          // set page title
          title = localStorage.getItem('title');
          document.title = getPageTitle(to.meta.title);
          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)();
          if (hasToken && localStorage.getItem('token') && localStorage.getItem('name')) {
            if (!getRouter) {
              //不加这个判断，路由会陷入死循环
              (0, _user.getMenu)({}).then(function (res) {
                if (res && res.length > 0) {
                  getRouter = ''; //后台拿到路由
                  getRouter = res; //后台拿到路由
                  saveObjArr('router', getRouter); //存储路由到localStorage
                  routerGo(to, next); //执行路由跳转方法
                } else {
                  window.localStorage.clear();
                  _nprogress.default.done();
                }
                // if(res.code==1){
              });
            } else {
              if (to.path === '/login') {
                // if is logged in, redirect to the home page
                next({
                  path: '/'
                });
                _nprogress.default.done();
              }
              next();
            }
            // if (to.path === '/login') {
            //   // if is logged in, redirect to the home page
            //   next({ path: '/' })
            //   NProgress.done()
            // } else {
            //   const hasGetUserInfo = store.getters.name
            //   if (hasGetUserInfo) {
            //     next()
            //   } else {
            //     try {
            //       // get user info
            //       // await store.dispatch('user/getInfo')
            //       next()
            //     } catch (error) {
            //       // remove token and go to login page to re-login
            //       // await store.dispatch('user/resetToken')
            //       Message.error(error || 'Has Error')
            //       next(`/login?redirect=${to.path}`)
            //       NProgress.done()
            //     }
            //   }
            // }
          } else {
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              // next(`/login?redirect=${to.path}`)
              next("/login");
              _nprogress.default.done();
            }
          }
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function (to, from, next) {
  // finish progress bar
  if (to.path == '/login') {
    document.title = _settings.default.title;
    getRouter = '';
    saveObjArr('router', getRouter); //存储路由到localStorage
    (0, _router2.resetRouter)();
    _store.default.dispatch('user/resetRouter', '');
  }
  _nprogress.default.done();
});
function routerGo(to, next) {
  getRouter = filterAsyncRouter(getRouter); //过滤路由
  getRouter.push({
    path: '*',
    redirect: '/404',
    hidden: true
  });
  (0, _router2.resetRouter)();
  _router.default.addRoutes(getRouter); //动态添加路由
  _store.default.dispatch('user/resetRouter', getRouter);
  next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
    replace: true
  }));
}
function saveObjArr(name, data) {
  //localStorage 存储数组对象的方法
  localStorage.setItem(name, JSON.stringify(data));
}
function getObjArr(name) {
  //localStorage 获取数组对象的方法
  return JSON.parse(window.localStorage.getItem(name));
}
function filterAsyncRouter(list) {
  //遍历后台传来的路由字符串，转换为组件对象
  var routerList = [];
  // if(!list)return [];

  list && list.forEach(function (item) {
    var routerObj = {
      path: item.path,
      name: item.name,
      hidden: false,
      children: filterAsyncRouter(item.children),
      meta: {
        title: item.title,
        icon: item.icon
      }
    };
    if (item.name == 'Survey') {
      if (item.children.length == 1) {
        routerObj.redirect = item.children[0].path;
      } else if (item.children.length == 0) {
        delete routerObj.children;
      }
    }
    if (item.url) {
      if (item.url === 'Layout') {
        routerObj.component = _layout.default;
      } else {
        try {
          routerObj.component = _import(item.url);
        } catch (e) {}
      }
    }
    if (item.hidden === false) {
      routerObj.hidden = true;
    }
    /*if(item.children.length==1){
      routerObj.redirect = item.children[0].path;
    }else if(item.children.length==0){
      delete routerObj.children
    }*/

    routerList.push(routerObj);
  });
  return routerList;
}